/** Normalize prompt.tools (array of ids or legacy object map) to a string[]. */
export function normalizePromptToolsList(tools) {
  if (Array.isArray(tools)) {
    return tools.map((x) => String(x || '').trim()).filter(Boolean);
  }
  if (tools && typeof tools === 'object') {
    return Object.keys(tools).map((k) => String(k || '').trim()).filter(Boolean);
  }
  return [];
}
